export default "__VITE_ASSET__BNDtz4sR__"